import 'zone.js';

//for ng2-dragula
(window as any).global = window;